module.exports = __webpack_public_path__ + "img/type2_check_2.eeda8b33.png";